<template>
  <div class="suggest-main">
    <div class="suggest-form-container">
      <div class="title">提交建议</div>
      <el-form
        class="suggest-form"
        ref="form"
        prop="type"
        :model="form"
        label-width="120px"
        :rules="rules"
      >
        <el-form-item class="form-item" label="建议类别：" prop="dataType">
          <el-radio-group v-model="form.dataType">
            <el-radio label="DATAISSUES">数据问题</el-radio>
            <el-radio label="DEMAND">需求申请</el-radio>
            <el-radio label="PLATFORM">平台体验</el-radio>
            <el-radio label="OTHER">其他</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-row>
          <el-col :span="10">
            <el-form-item class="form-item" label="建议标题：" prop="title">
              <el-input v-model="form.title"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2">
            <div style="color: transparent">
              占位符
            </div>
          </el-col>

          <el-col :span="10">
            <el-form-item class="form-item" prop="name" label="姓名：">
              <el-input v-model="form.name"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="10">
            <el-form-item class="form-item" label="建议内容：" prop="content">
              <el-input
                type="textarea"
                :autosize="{ minRows: 6, maxRows: 6 }"
                v-model="form.content"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2">
            <div style="color: transparent">
              占位符
            </div>
          </el-col>
          <el-col :span="10">
            <el-form-item class="form-item" label="联系电话：" prop="phone">
              <el-input type="input" v-model="form.phone"></el-input>
            </el-form-item>
            <el-form-item class="form-item" label="电子邮件：" prop="email">
              <el-input type="input" v-model="form.email"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item class="acenter">
          <el-button
            class="big-button submit-button"
            type="primary"
            @click="onSubmit"
            >提交</el-button
          >
          <el-button class="big-button reset-button" @click="reset"
            >重置</el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { feedback } from "@/api/index";
export default {
  data() {
    return {
      form: {
        title: "",
        content: "",
        dataType: "",
        email: "",
        phone: "",
        name: ""
      },
      rules: {
        title: [{ required: true, trigger: "blur", message: "请输入标题" }],
        content: [{ required: true, trigger: "blur", message: "请选择内容" }],
        dataType: [{ required: true, trigger: "blur", message: "请选中类型" }],
        email: [{ required: true, trigger: "blur", message: "请输入邮箱" }],
        phone: [
          { required: true, trigger: "blur", message: "请输入手机号" },
          {
            pattern: /^[1]([3-9])[0-9]{9}$/,
            message: "手机号格式不对",
            trigger: "blur"
          }
        ],
        name: [{ required: true, trigger: "blur", message: "请选择姓名" }]
      }
    };
  },

  methods: {
    onSubmit() {
      this.$refs["form"].validate(async valid => {
        if (valid) {
          const { message } = await feedback(this.form);
          this.$baseMessage(message, "success");
          this.$emit("fetch-data");
          this.reset();
        } else {
          return false;
        }
      });
    },
    reset() {
      this.form = {
        name: "",
        type: "",
        mobile: "",
        email: "",
        content: "",
        title: ""
      };
      this.$refs["form"].resetFields();
    }
  }
};
</script>

<style lang="scss" scoped>
.suggest-main {
  background: $base-color-white;
}
.form-item .el-form-item__label {
  font-size: 16px !important;
  font-weight: 500 !important;
  color: #333333 !important;
  line-height: 22px !important;
}
.suggest-form-container {
  width: 1190px;
  margin: 0 auto;
  padding-bottom: 40px;
  padding-top: 30px;
  .title {
    font-size: 24px;
    font-weight: 500;
    color: #333333;
    line-height: 33px;
    margin-bottom: 40px;
    text-align: center;
  }
  .suggest-form {
    .acenter {
      display: flex;
      flex-direction: row;
      justify-content: center;
      .big-button {
        width: 228px;
        height: 56px;
        border-radius: 4px;
        font-size: 24px;
      }
      .submit-button {
        background: $base-theme-color;
      }
      .reset-button {
        margin-left: 70px;
        border: 1px solid $base-theme-color;
        color: $base-theme-color;
      }
    }
  }
}
</style>
